// Animation Variants
const containerVariants = {
    hidden: {opacity: 0, y: 20},
    visible: {opacity: 1, y: 0, transition: {duration: 0.6, ease: "easeOut"}}
};

const inputVariants = {
    hidden: {opacity: 0, x: -10},
    visible: {opacity: 1, x: 0, transition: {duration: 0.4, ease: "easeOut"}}
};

const buttonVariants = {
    hover: {scale: 1.00, transition: {duration: 0.2, ease: "easeInOut"}}
};

const contentVariants = {
    initial: { y: 30, opacity: 0 },
    animate: { y: 0, opacity: 1, transition: { duration: 0.4, ease: "easeInOut" } },
    exit: { y: -30, opacity: 0, transition: { duration: 0.3, ease: "easeInOut" } },
};

const iconVariants = {
    initial: { scale: 0.9, opacity: 0 },
    animate: { scale: 1, opacity: 1, transition: { duration: 0.5, ease: "easeOut" } },
};

const footerItemVariants = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut", staggerChildren: 0.1 } },
};

const chatPanelVariants = {
    initial: {opacity: 0, scale: 0.95},
    animate: {opacity: 1, scale: 1},
    exit: {opacity: 0, scale: 0.95},
    transition: {duration: 0.5, ease: "easeInOut"}
}

const authFormVariants = {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1, transition: { duration: 0.5, delay: 0.3 } },
};

export const getFadeInUpVariant = (delay = 0, duration = 0.5) => ({
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0, transition: { duration, delay } },
});



export {
    containerVariants,
    inputVariants,
    buttonVariants,
    chatPanelVariants,
    contentVariants,
    iconVariants,
    footerItemVariants,
    authFormVariants
}
